import { Injectable } from '@angular/core';
import { EntityManager } from '@proximus/entity-manager';
import { SplitUnbilledBalanceEntity } from '../configs/entity.config';

@Injectable({
  providedIn: 'root',
})
export class SplitUnbilledBalanceService {
  constructor() {}

  getSplitUnbilledBalance(payload: any) {
    return EntityManager.getEntity(SplitUnbilledBalanceEntity, {
      serviceId: payload.serviceId,
    });
  }
}
